<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: 'Edit'
}
</script>

<style scoped>

</style>
